<div *ngIf="showPreview" class="input-row">
    <div style="display: flex;">
      <input 
        type="text" 
        class="key" 
        placeholder="Key" 
        [(ngModel)]="key"
        (input)="addKey()"
        [disabled]="pairValue?.disableKey || pairValue?.isArrayItem"/>

      <div style="display: flex; flex-direction:column;">
        <div style="display: flex;">
          <ng-select
            class="type custom-ng-select"
            [(ngModel)]="type"
            [searchable]="false"
            [typeahead]="false"
            [clearable]="false"
            (change)="addKey()"
            [disabled]="pairValue?.disableType">

            <ng-option *ngFor="let elem of listOfTypes" [value]="elem">
              {{ elem }}
            </ng-option>
          </ng-select>

          <button *ngIf="!pairValue?.disableRemove" class="delete-row" (click)="deleteItem()"> Remove </button>
        </div>
        
        <div style="display: flex;">
          <div style="display: flex; position: relative; max-width: min-content;">
            <input
              [type]="type === 'Number' ? 'number' : 'text'"
              class="value"
              placeholder="Value"
              [(ngModel)]="value"
              *ngIf="(type === 'String' && (value?.length < 30 || !value?.length)) || type === 'Number'"
              [disabled]="pairValue?.disableValue || type === 'Object' || type === 'Boolean'"
              (input)="addKey()"
            />
            <textarea
              class="value"
              placeholder="Value"
              [(ngModel)]="value"
              *ngIf="type === 'String' && value?.length >= 30"
              [disabled]="pairValue?.disableValue || type === 'Object' || type === 'Boolean'"
              (input)="addKey()"
              rows="3"
            >
            </textarea>
            <!-- <div class="clear-value" *ngIf="type !== 'Object' && type !== 'Boolean'" (click)="clearValue()"> + </div> -->
            <!-- <a *ngIf="type !== 'Object' && type !== 'Boolean' && type !== 'Null'" (click)="clearValue()" href="#" class="clear-value">
              <i class="m-menu__link-icon flaticon-cancel"></i>
            </a> -->
          </div>
          <button class="boolean-toggle" *ngIf="type === 'Boolean'" (click)="handleBoolean()" [disabled]="pairValue?.disableValue"> Set {{ value ? 'False' : 'True'}} </button>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!showPreview" class="input-row-hide-preview">
      <input 
        type="text" 
        class="key" 
        placeholder="Key" 
        [(ngModel)]="key"
        (input)="addKey()"
        [disabled]="pairValue?.disableKey || pairValue?.isArrayItem"/>

        <ng-select
          class="type custom-ng-select"
          [(ngModel)]="type"
          [searchable]="false"
          [typeahead]="false"
          [clearable]="false"
          (change)="addKey()"
          [disabled]="pairValue?.disableType">

          <ng-option *ngFor="let elem of listOfTypes" [value]="elem">
            {{ elem }}
          </ng-option>
        </ng-select>

        <input
          [type]="type === 'Number' ? 'number' : 'text'"
          class="value"
          placeholder="Value"
          [(ngModel)]="value"
          *ngIf="(type === 'String' && (value?.length < 30 || !value?.length)) || type === 'Number'"
          [disabled]="pairValue?.disableValue || type === 'Object' || type === 'Boolean'"
          (input)="addKey()"/>

          <textarea
            class="value"
            placeholder="Value"
            [(ngModel)]="value"
            *ngIf="type === 'String' && value?.length >= 30"
            [disabled]="pairValue?.disableValue || type === 'Object' || type === 'Boolean'"
            (input)="addKey()"
            rows="3">
          </textarea>

          <!-- <a *ngIf="type !== 'Object' && type !== 'Boolean' && type !== 'Null'" (click)="clearValue()" href="#" class="clear-value">
            <i class="m-menu__link-icon flaticon-cancel"></i>
          </a> -->

          <button class="boolean-toggle" *ngIf="type === 'Boolean'" (click)="handleBoolean()" [disabled]="pairValue?.disableValue"> Set {{ value ? 'False' : 'True'}} </button>
          <button *ngIf="!pairValue?.disableRemove" class="delete-row" (click)="deleteItem()"> Remove </button>
  </div>
